import React from 'react';
import { IInputProps } from '../input';

export const ErrorShower = ({ errors, name }: IInputProps) => {
	return (
		<>
			{errors && errors[name as string] && (
				<p className="text-error font-semibold text-base">{errors[name as string].message}</p>
			)}
		</>
	);
};
